"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_OK = exports.STATUS_NOT_FOUND = exports.STATUS_INTERNAL_SERVER_ERROR = void 0;
const STATUS_OK = exports.STATUS_OK = 200;
const STATUS_NOT_FOUND = exports.STATUS_NOT_FOUND = 404;
const STATUS_INTERNAL_SERVER_ERROR = exports.STATUS_INTERNAL_SERVER_ERROR = 500;
//# sourceMappingURL=statusCodes.js.map